const TabPanel = ({ children }) => children;

export default TabPanel;
